import {
  FormTokenChainState,
  PersistedFormTokenChainState,
  PersistedFormTokenNode,
  TokenId,
} from '../types/context';

// Persisted shape for the localStorage blob: node stays complete except meta,
// which is replaced by the id of its IndexedDB record (the node id itself)
export const dehydrateFormTokensMeta = (
  formTokens: FormTokenChainState
): PersistedFormTokenChainState => {
  const persistedNodes: Record<TokenId, PersistedFormTokenNode> = {};

  Object.values(formTokens.nodes).forEach((node) => {
    const { meta, ...nodeWithoutMeta } = node;
    persistedNodes[node.id] = {
      ...nodeWithoutMeta,
      ...(meta && { meta: node.id }),
    };
  });

  return { nodes: persistedNodes, roots: formTokens.roots };
};
